const STEAM_ECONOMY_IMAGE =
  /^https:\/\/(community\.(akamai|cloudflare|fastly)\.steamstatic\.com|steamcommunity-a\.akamaihd\.net)\/economy\/image\/[^/?#]+$/;

const STEAM_NATIVE_WIDTH = 512;
const STEAM_WIDTHS = [128, 256, 384] as const;

export const isSteamEconomyImage = (src: string): boolean => STEAM_ECONOMY_IMAGE.test(src);

// WHY: исходник у Steam 512×384, суффикс WfxHf отдаёт ровно W×H — высота держит те же 4:3; шире исходника не просим: Steam
// только растянет, а голый адрес и так уже в кэше CDN от ленты дропов
export const steamImageLoader = ({ src, width }: { src: string; width: number }): string => {
  const bucket = STEAM_WIDTHS.find((candidate) => width <= candidate);
  return bucket ? `${src}/${bucket}fx${(bucket * 3) / 4}f` : src;
};

export const steamImageSrcSet = (src: string): string =>
  [...STEAM_WIDTHS.map((width) => `${steamImageLoader({ src, width })} ${width}w`), `${src} ${STEAM_NATIVE_WIDTH}w`].join(', ');

// WHY: ровно один шаг — с оптимизатора Next на CDN Steam; ошибка уже прямого адреса ничего не меняет, иначе цикл перезагрузок
export const steamFallbackOnError = (src: string, fallenBackFor: string | null): string | null =>
  isSteamEconomyImage(src) && fallenBackFor !== src ? src : null;
